import { render, staticRenderFns } from "./SurveyCampaign.vue?vue&type=template&id=72100a9a"
import script from "./SurveyCampaign.vue?vue&type=script&lang=js"
export * from "./SurveyCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports